import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI, getToken, getUser, setToken, setUser, clearAuth } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUserState] = useState(() => getUser());
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) { setLoading(false); return; }

    // Always fetch fresh — ensures avatar_url, cover_url, bio are current
    const API = process.env.REACT_APP_API_URL || 'http://localhost:5002/api/v1';
    fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        const u = d?.data || d?.user;
        if (u?.id) { setUser(u); setUserState(u); }
        else {
          // Fall back to cached user if fetch fails
          const cached = getUser();
          if (cached?.id) setUserState(cached);
        }
      })
      .catch(() => {
        const cached = getUser();
        if (cached?.id) setUserState(cached);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await authAPI.login({ email, password });
    const data = r.data?.data || r.data;
    const token = data?.token || data?.accessToken;
    const u = data?.user;
    if (token) setToken(token);
    if (u) { setUser(u); setUserState(u); }
    return u;
  };

  const logout = () => { clearAuth(); setUserState(null); };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);